import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SvgIcons } from '@niceltd/cxone-components/shared-services';
import * as i1 from '@angular/platform-browser';
class EmbeddedMessagesComponent {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
    this.svgIcons = new SvgIcons(this.sanitizer);
  }
  ngOnInit() {
    this.icon = this.svgIcons.getSvgIcons(this.messageType);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function EmbeddedMessagesComponent_Factory(t) {
      return new (t || EmbeddedMessagesComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: EmbeddedMessagesComponent,
      selectors: [["cxone-embedded-messages"]],
      inputs: {
        embeddedMessageId: "embeddedMessageId",
        messageType: "messageType",
        messageData: "messageData"
      },
      decls: 4,
      vars: 7,
      consts: [[3, "id"], ["role", "img", 1, "embedded-messages-icon", 3, "innerHTML"], [1, "embedded-messages-text"]],
      template: function EmbeddedMessagesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("embedded-messages ", ctx.messageType, "");
          i0.ɵɵpropertyInterpolate("id", ctx.embeddedMessageId);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.icon, i0.ɵɵsanitizeHtml);
          i0.ɵɵattribute("aria-label", ctx.messageType);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.messageData);
        }
      },
      styles: [".embedded-messages{display:inline-flex;align-items:flex-start;padding:10px 10px 10px 13px;background:#fff;border:1px solid;box-sizing:border-box;width:100%}.embedded-messages-icon{width:20px;height:20px;margin-right:10px;min-height:1.25rem;min-width:1.25rem}.embedded-messages-text{margin-top:2px;color:#2e2e2e;font-size:13px;font-family:OpenSans;word-break:break-word;-webkit-hyphens:auto;hyphens:auto;white-space:pre-line;line-height:1.05rem}.embedded-messages svg{margin-top:-2px}.embedded-messages.user-info,.embedded-messages.system-info{border-color:#43a8de;background:#e8f7ff}.embedded-messages.user-warning,.embedded-messages.system-warning{border-color:#efa716;background:#fcf7ec}.embedded-messages.user-error,.embedded-messages.system-error{border-color:#f1626d;background:#fff2f3}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmbeddedMessagesComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-embedded-messages',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"embedded-messages {{messageType}}\" id=\"{{embeddedMessageId}}\">\n  <div class=\"embedded-messages-icon\" [innerHTML]=\"icon\" role=\"img\" [attr.aria-label]=\"messageType\" >\n  </div>\n  <div class=\"embedded-messages-text\">{{messageData}}</div>\n</div>\n",
      styles: [".embedded-messages{display:inline-flex;align-items:flex-start;padding:10px 10px 10px 13px;background:#fff;border:1px solid;box-sizing:border-box;width:100%}.embedded-messages-icon{width:20px;height:20px;margin-right:10px;min-height:1.25rem;min-width:1.25rem}.embedded-messages-text{margin-top:2px;color:#2e2e2e;font-size:13px;font-family:OpenSans;word-break:break-word;-webkit-hyphens:auto;hyphens:auto;white-space:pre-line;line-height:1.05rem}.embedded-messages svg{margin-top:-2px}.embedded-messages.user-info,.embedded-messages.system-info{border-color:#43a8de;background:#e8f7ff}.embedded-messages.user-warning,.embedded-messages.system-warning{border-color:#efa716;background:#fcf7ec}.embedded-messages.user-error,.embedded-messages.system-error{border-color:#f1626d;background:#fff2f3}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }], {
    embeddedMessageId: [{
      type: Input
    }],
    messageType: [{
      type: Input
    }],
    messageData: [{
      type: Input
    }]
  });
})();
class EmbeddedMessagesModule {
  /** @nocollapse */static {
    this.ɵfac = function EmbeddedMessagesModule_Factory(t) {
      return new (t || EmbeddedMessagesModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: EmbeddedMessagesModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmbeddedMessagesModule, [{
    type: NgModule,
    args: [{
      declarations: [EmbeddedMessagesComponent],
      imports: [CommonModule, FormsModule],
      providers: [],
      exports: [EmbeddedMessagesComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { EmbeddedMessagesComponent, EmbeddedMessagesModule };
